import {type StoppageDto, StoppageKind, type StoppageType} from '@hconnect/common/types'
import {merge} from 'lodash'

export const isStoppageTypeForNewWithCodeOldWithReason = (stoppageType: StoppageType): boolean =>
  stoppageType === 'alternativeFuelInstallation'

export const isStoppageTypeWithReason = (stoppageType: StoppageType): boolean =>
  stoppageType === 'other' ||
  stoppageType === 'coalMill' ||
  stoppageType === 'crusher' ||
  stoppageType === 'bypass' ||
  isStoppageTypeForNewWithCodeOldWithReason(stoppageType)

export const isStoppageTypeWithCode = (stoppageType: StoppageType): boolean =>
  stoppageType === 'kiln' ||
  stoppageType === 'cementMill' ||
  stoppageType === 'rawMill' ||
  isStoppageTypeForNewWithCodeOldWithReason(stoppageType)

export function stoppageDefaultObject<T>(initialData: T): Partial<StoppageDto> {
  const defaultRequiredData = {
    eventType: StoppageKind.Incident,
    status: 'none',
    title: '',
    description: '',
    stoppageType: 'kiln'
  }
  const stoppage = {...defaultRequiredData, ...initialData} as Partial<StoppageDto>

  if (isStoppageTypeWithCode(stoppage.stoppageType as StoppageType)) {
    merge(stoppage, {stoppageCode: undefined})
  } else {
    merge(stoppage, {stoppageReason: undefined})
  }

  return stoppage
}
